"use client"

import type { ImageLoaderProps } from "next/image"

const imgDomain = process.env.DIRECTUS_ASSETS_URL ?? ""

interface DirectusImageProps {
  fit?: "cover" | "contain" | "inside" | "outside"
}

export default function directusImageLoader({
  src: imageID,
  width,
  quality,
  fit,
}: ImageLoaderProps & DirectusImageProps) {
  const url = new URL(`${imgDomain}${imageID}`)

  // Optimize image loading
  url.searchParams.set("fit", fit ?? "contain")
  url.searchParams.set("width", width.toString())
  url.searchParams.set("quality", quality?.toString() || "75")
  url.searchParams.set("format", "webp") // Use WebP by default
  url.searchParams.set("optimize", "true")

  // Add responsive sizing
  if (width <= 640) {
    url.searchParams.set("quality", "70")
  } else if (width <= 1200) {
    url.searchParams.set("quality", "75")
  } else {
    url.searchParams.set("quality", "80")
  }

  return url.href
}
